interface L10nObject {
  name?: string
  l10n?: string
}

interface Exercise extends L10nObject {
  scope?: string
  site?: string
}

interface Machine extends L10nObject {
  enabled?: boolean
  exercises?: Exercise[]
}

interface Program extends L10nObject {
  scope?: string
  site?: string
}

interface Routine extends L10nObject {
  scope?: string
  site?: string
  exercises?: Exercise[]
}

interface Gym extends L10nObject {}

export function generateL10n(name: string): string {
  return name.replace(/[^a-zA-Z0-9]/g, '').replace(/[^\w\s]/gi, '').toLowerCase()
  // return name.replace(/[ #–&-1234567890]/g, '').replace(/[^\w\s]/gi, '').toLowerCase()
}

function addL10n<T extends L10nObject>(obj: T): T {
  if (obj && obj.name) {
    obj.l10n = generateL10n(obj.name)
  }
  return obj
}

function removeL10n<T extends L10nObject>(obj: T | null | undefined): T | null | undefined {
  if (obj && obj.l10n) {
    obj.l10n = ""
  }
  return obj
}

export function addL10nGym(gym: Gym | null | undefined): Gym | null | undefined {
  if (gym) {
    addL10n(gym)
  } else {
    removeL10n(gym)
  }
  return gym
}

export function addL10nMachine(machine: Machine | null | undefined): Machine | null | undefined {
  if (
    machine &&
    machine.enabled &&
    machine.exercises &&
    machine.exercises.length > 0
  ) {
    addL10n(machine)
    machine.exercises.forEach(e => addL10n(e))
  } else if (machine) {
    removeL10n(machine)
  }
  return machine
}

export function addL10nProgram(program: Program | null | undefined): Program | null | undefined {
  if (program && (program.scope == 'curated' || program.scope == 'import') && !program.site) {
    addL10n(program)
  } else if (program) {
    removeL10n(program)
  }
  return program
}

export function addL10nRoutine(routine: Routine | null | undefined): Routine | null | undefined {
  if (routine && (routine.scope == 'curated' || routine.scope == 'import') && !routine.site) {
    addL10n(routine)
    if (routine.exercises) {
      routine.exercises.forEach(e => addL10n(e))
    }
  } else if (routine) {
    removeL10n(routine)
  }
  return routine
}

export function addL10nExercise(exercise: Exercise | null | undefined): Exercise | null | undefined {
  if (
    exercise &&
    (exercise.scope == 'curated' || exercise.scope == 'public') &&
    !exercise.site
  ) {
    addL10n(exercise)
  } else if (exercise) {
    removeL10n(exercise)
  }
  return exercise
}